export default {"src":"/_next/static/media/netflix.902dc101.svg","height":40,"width":40};